// extracted by mini-css-extract-plugin
export default {"securityKeyBox":"tEGBd0Bmaz3jxpOIlyTf"};